import { render, staticRenderFns } from "./ArchiveVerify.vue?vue&type=template&id=e24421b6&"
import script from "./ArchiveVerify.vue?vue&type=script&lang=js&"
export * from "./ArchiveVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports